import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ThemeService, ThemeName, ThemeMode } from '../../services/theme.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-theme-switcher',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    MatSlideToggleModule
  ],
  templateUrl: './theme-switcher.component.html',
  styleUrl: './theme-switcher.component.scss'
})
export class ThemeSwitcherComponent implements OnInit {
  currentTheme$: Observable<ThemeName>;
  currentMode$: Observable<ThemeMode>;
  availableThemes: { name: ThemeName; displayName: string }[];
  isDarkMode: boolean = false;

  constructor(public themeService: ThemeService) {
    this.currentTheme$ = this.themeService.currentTheme$;
    this.currentMode$ = this.themeService.currentMode$;
    this.availableThemes = this.themeService.availableThemes;
  }

  ngOnInit(): void {
    // Subscribe to mode changes to update the toggle
    this.currentMode$.subscribe(mode => {
      this.isDarkMode = mode === 'dark';
    });
  }

  /**
   * Select a theme
   */
  selectTheme(theme: ThemeName): void {
    this.themeService.setTheme(theme);
  }

  /**
   * Toggle between light and dark mode
   */
  toggleDarkMode(): void {
    this.themeService.toggleMode();
  }

  /**
   * Get the display name for current theme
   */
  getCurrentThemeDisplay(): string {
    const currentTheme = this.themeService.getCurrentTheme();
    const theme = this.availableThemes.find(t => t.name === currentTheme);
    return theme ? theme.displayName : '';
  }
}
